
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmEmailComponent } from './authentication/confirm-email/confirm-email.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { LoginWrapperComponent } from './authentication/login-wrapper/login-wrapper.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { NewPasswordComponent } from './authentication/new-password/new-password.component';
import { NewSignupComponent } from './authentication/new-signup/new-signup.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { VerifyEmailComponent } from './authentication/verify-email/verify-email.component';
import { AgencyGuard } from './guards/agency.guard';
import { AuthGuard } from './guards/auth.guard';
import { LoginRegisterGuard } from './guards/login-register.guard';
import { WidgetGuard } from './guards/widget.guard';
import { OAuthRedirectComponent } from './modules/bot-builder/components/integrations/components/all-integration/components/providers/o-auth-redirect/o-auth-redirect.component';
import { UnsubscribeComponent } from './modules/unsubscribe/unsubscribe.component';
import { SingleSessionComponent } from './modules/single-session/single-session.component';
import { SingleSessionGuard } from './guards/single-session.guard';


const routes: Routes = [
  { path: 'login', redirectTo: '/authentication', pathMatch: 'full' },
  { path: 'authentication', component: NewSignupComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard]},

  { path: 'session', component: SingleSessionComponent },

  {
    path: 'home', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [SingleSessionGuard, AuthGuard],
  },
  {
    path: 'bot-builder', loadChildren: () => import('./modules/bot-builder/bot-builder.module').then(m => m.BotBuilderModule),
    canLoad: [AuthGuard], canActivate: [SingleSessionGuard]
  },
  {
    path: 'inbox', loadChildren: () => import('./modules/inbox/inbox.module').then(m => m.InboxModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'inbox-merged', loadChildren: () => import('./modules/inbox-merged/inbox-merged.module').then(m => m.InboxMergedModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'bot-builder/onboarding', loadChildren: () => import('./modules/bot-builder/bot-builder.module').then(m => m.BotBuilderModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'analytics', loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'team', loadChildren: () => import('./modules/team/team.module').then(m => m.TeamModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'subscription', loadChildren: () => import('./modules/subscription/subscription.module').then(m => m.SubscriptionModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'notification', loadChildren: () => import('./modules/notification/notification.module').then(m => m.NotificationModule),
    canLoad: [AuthGuard],  canActivate: [SingleSessionGuard]
  },
  {
    path: 'settings', loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
    canLoad: [AuthGuard], canActivate: [SingleSessionGuard]
  },
  {
    path: 'developer', loadChildren: () => import('./modules/developer/developer.module').then(m => m.DeveloperModule),
    canLoad: [AuthGuard], canActivate: [SingleSessionGuard]
  },
  {
    path: 'agency', loadChildren: () => import('./modules/agency/agency.module').then(m => m.AgencyModule),
    canLoad: [AuthGuard, AgencyGuard], canActivate: [SingleSessionGuard]
  },
  {
    path: 'whitelabel', loadChildren: () => import('./modules/whitelabel/whitelabel.module').then(m => m.WhitelabelModule),
    canLoad: [AuthGuard], canActivate: [SingleSessionGuard]
  },
  {
    path: 'widgets', loadChildren: () => import('./modules/widgets/widgets.module').then(m => m.WidgetsModule),
  },
  {
    path: 'access-control', loadChildren: () => import('./modules/access-control/access-control.module').then(m => m.AccessControlModule),
    canLoad: [AuthGuard], canActivate: [SingleSessionGuard]
  },
  { path: 'new-password', component: NewPasswordComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard], },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard]},
  { path: 'confirm-email', component: ConfirmEmailComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard], },
  { path: 'verify-email', component: VerifyEmailComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard], },
  { path: 'api-login', component: LoginWrapperComponent, canActivate: [SingleSessionGuard, LoginRegisterGuard] },
  { path: 'reset-password', component: ResetPasswordComponent,  canActivate: [SingleSessionGuard] },
  { path: 'logout', component: LogoutComponent,  canActivate: [SingleSessionGuard] },
  { path: 'zoho-desk.html', component: OAuthRedirectComponent },
  { path: 'zoho-projects.html', component: OAuthRedirectComponent },
  { path: 'zoho-crm.html', component: OAuthRedirectComponent },
  { path: 'google-redirect.html', component: OAuthRedirectComponent },
  { path: 'outlook.html', component: OAuthRedirectComponent},
  { path: 'salesforce-crm.html', component: OAuthRedirectComponent },
  { path: 'google-sheets.html', component: OAuthRedirectComponent },
  { path: 'google-contacts.html', component: OAuthRedirectComponent },
  { path: 'google-task.html', component: OAuthRedirectComponent },
  { path: 'google-calendar.html', component: OAuthRedirectComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent, canActivate: [SingleSessionGuard] },
  { path: '**', redirectTo: '/authentication', pathMatch: 'full' },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      enableTracing: false,
      onSameUrlNavigation: 'reload'
    }),
  ],
  exports: [RouterModule],
})



export class AppRoutingModule {
}
